import logger from '../utilities/logger'

const Api = {
  install(Vue, options) {
      Vue.prototype.$api = {
        book: function (wishId, wishOwner, component, okFunction) {
          logger.log("book", {wishId, wishOwner})
          Vue.http.put(options.baseApiUrl + 'reservations/' + wishId + '?owner=' + wishOwner, "").then(() => {
            okFunction(component)
          }, (response) => {
            response.json().then((data) => {
              logger.log("ERROR:" + data)
            }).catch(logger.log("ERROR:" + response))
          })
        },
        unbook: function (wishId, wishOwner, component, okFunction) {
            Vue.http.delete(options.baseApiUrl + 'reservations/' + wishId + '?owner=' + wishOwner).then(() => {
                okFunction(component)
              }, (response) => {
                response.json().then((data) => {
                  logger.log("ERROR:" + data)
                }).catch(logger.log("ERROR:" + response))
              })
        },
        delete: function(wishId, impersonate, component, okFunction) {
          let headers = {
            'x-delegate-for': impersonate
          }
          if(impersonate == undefined) {
            headers = undefined
          }          
          Vue.http.delete(options.baseApiUrl + 'wishes/' + wishId, {headers}).then(() => {        
            okFunction(component)
          }, response => {
            response.json().then((data) => {
              logger.log("ERROR:" + data)
            }).catch(logger.log("ERROR:" + response))
          });
        },
        upsert: function(wishId, wish, impersonate, component, okFunction = null) {
          let headers = {
            'x-delegate-for': impersonate
          }
          if(impersonate == undefined) {
            headers = undefined
          }          
          console.log(impersonate)
          Vue.http.put(options.baseApiUrl + 'wishes/' + wishId, wish, {headers}).then(() => {
            component.$toast.open('Save!');
            if(okFunction != null) {
              let returnUser = component.$oauth.getCurrentUser()
              if(impersonate != undefined){
                returnUser = impersonate
              }
              okFunction(component, returnUser)
            }
          }, response => {
            response.json().then((data) => {
              logger.log("ERROR:" + data)
            }).catch(logger.log("ERROR:" + response))
          });
        },
        userlist: function(component, okFunction) {
          Vue.http.get(options.baseApiUrl + 'users').then((response) => {
            response.json().then((data) => {
              okFunction(component, data)
            })
          }, (response) => {
            response.json().then((data) => {
              logger.log("ERROR:" + data)
            }).catch(logger.log("ERROR:" + response))
          })
        },
        wishlist: function(wishOwner,component, okFunction, errFunction = null) {
          Vue.http.get(options.baseApiUrl + 'wishes?owner=' + wishOwner).then((response) => {
            response.json().then((data) => {
              okFunction(component, data, wishOwner)
            })
          }, (response) => {
            if(errFunction != null) {
              errFunction(component, wishOwner)
            }
            response.json().then((data) => {
              logger.log("ERROR:" + data)
            }).catch(logger.log("ERROR:" + response))
          })
        },
        byAsin: function(asin,component, okFunction) {
          Vue.http.get(options.baseApiUrl + 'items?key='+asin).then((response) => {
            response.json().then((data) => {
              okFunction(component, data)
            })
          }, (response) => {
            response.json().then((data) => {
              logger.log("ERROR:" + data)
            }).catch(logger.log("ERROR:" + response))
          })
        },
        priorityChange: function(list, impersonate, component, okFunction) {
          let headers = {
            'x-delegate-for': impersonate
          }
          if(impersonate == undefined) {
            headers = undefined
          }          
          Vue.http.post(options.baseApiUrl  + 'priority', list, {headers}).then(() => {
            let returnUser = component.$oauth.getCurrentUser()
            if(impersonate != undefined){
              returnUser = impersonate
            }
            okFunction(component, returnUser)
          }, (response) => {
            response.json().then((data) => {
              logger.log("ERROR:" + data)
            }).catch(logger.log("ERROR:" + response))
          })
          
        }
      }
  }
};

export default Api;